import React from 'react';
import { Link } from 'react-router-dom';
import BackgammonPage from './BackgammonPage';
import './Backgammon.css';

// Public standalone page at /backgammon: anyone can watch; playing needs an
// account. The lobby/table themselves gate the play actions on sign-in.
export default function BackgammonPublicPage() {
  let isLoggedIn = false;
  try { isLoggedIn = !!localStorage.getItem('access_token'); } catch (e) { /* private mode */ }
  return (
    <div className="bg-root bg-public">
      <div className="bg-public-bar">
        <span className="bg-public-title">🎲 Dijon Backgammon</span>
        {isLoggedIn
          ? <Link className="bg-btn bg-btn-quiet" to="/">← dashboard</Link>
          : <Link className="bg-btn bg-btn-primary" to="/login">sign in to play</Link>}
      </div>
      <BackgammonPage />
    </div>
  );
}
